// Action types
const MAIN_MENU_TOGGLE = "MAIN_MENU_TOGGLE";
const SET_BOOK = "SET_BOOK";
const SET_ACTIVE_CHAPTER_ID = "SET_ACTIVE_CHAPTER_ID";
const SET_POSITION_IN_CHAPTER = "SET_POSITION_IN_CHAPTER";
const SET_USER_CODE = "SET_USER_CODE";
const SET_REACT_USER_CODE = "SET_REACT_USER_COD";
const SET_CSS_USER_CODE = "SET_CSS_USER_CODE";
const SET_ORIGINAL_CODE = "SET_ORIGINAL_CODE";
const SET_ORIGINAL_REACT_CODE = "SET_ORIGINAL_REACT_CODE";
const SET_USER_TOKEN = "SET_USER_TOKEN";
const SET_USER_ID = "SET_USER_ID";

// Action creators

export const doMainMenuToggle = () => ({
  type: MAIN_MENU_TOGGLE
});

export const doSetBook = book => ({
  type: SET_BOOK,
  book
});

export const doSetActiveChapterId = activeChapterId => ({
  type: SET_ACTIVE_CHAPTER_ID,
  activeChapterId
});

export const doSetUserToken = token => ({
  type: SET_USER_TOKEN,
  token
});

export const doSetUserId = id => ({
  type: SET_USER_ID,
  id
});

export const doSetPositionInChapter = (chapter, block, position) => ({
  type: SET_POSITION_IN_CHAPTER,
  chapter,
  block,
  position
});

export const doSetUserCode = (activeChapterId, codeId, code) => ({
  type: SET_USER_CODE,
  activeChapterId,
  codeId,
  code
});

export const doSetUserReactCode = (activeChapterId, codeId, code) => ({
  type: SET_REACT_USER_CODE,
  activeChapterId,
  codeId,
  code
});

export const doSetCssUserCss = (activeChapterId, codeId, code) => ({
  type: SET_CSS_USER_CODE,
  activeChapterId,
  codeId,
  code
});

export const doSetOriginalCode = (activeChapterId, codeId) => ({
  type: SET_ORIGINAL_CODE,
  activeChapterId,
  codeId
});

export const doSetOriginalReactCode = (activeChapterId, codeId) => ({
  type: SET_ORIGINAL_REACT_CODE,
  activeChapterId,
  codeId
});

const getBookFromLocalStorage = () =>
  JSON.parse(localStorage.getItem("makers.book")) || null;

const initialState = {
  book: getBookFromLocalStorage(),
  user: {
    id: null,
    token: null,
    avatarUrl: ""
  },
  appState: {
    mainMenu: {
      open: false
    }
  }
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case MAIN_MENU_TOGGLE:
      return {
        ...state,
        appState: {
          ...state.appState,
          mainMenu: {
            ...state.appState.mainMenu,
            open: !state.appState.mainMenu.open
          }
        }
      };
    case SET_BOOK:
      return {
        ...state,
        book: action.book
      };
    case SET_ACTIVE_CHAPTER_ID:
      return {
        ...state,
        book: {
          ...state.book,
          activeChapterId: action.activeChapterId
        }
      };

    case SET_POSITION_IN_CHAPTER:
      return {
        ...state,
        book: {
          ...state.book,
          chapters: state.book.chapters.map(
            chapter =>
              chapter.id === action.chapter
                ? {
                    ...chapter,
                    block: action.block,
                    position: action.position
                  }
                : chapter
          )
        }
      };
    case SET_USER_CODE:
      return {
        ...state,
        book: {
          ...state.book,
          chapters: state.book.chapters.map(
            chapter =>
              chapter.id === action.activeChapterId
                ? {
                    ...chapter,
                    content: chapter.content.map(
                      item =>
                        ["HTML", "HTML_WITH_CSS"].includes(item.type) &&
                        item.id === action.codeId
                          ? {
                              ...item,
                              htmlCodeUser: action.code
                            }
                          : item
                    )
                  }
                : chapter
          )
        }
      };
    case SET_REACT_USER_CODE:
      return {
        ...state,
        book: {
          ...state.book,
          chapters: state.book.chapters.map(
            chapter =>
              chapter.id === action.activeChapterId
                ? {
                    ...chapter,
                    content: chapter.content.map(
                      item =>
                        item.type === "REACT" && item.id === action.codeId
                          ? {
                              ...item,
                              reactCodeUser: action.code
                            }
                          : item
                    )
                  }
                : chapter
          )
        }
      };
    case SET_CSS_USER_CODE:
      return {
        ...state,
        book: {
          ...state.book,
          chapters: state.book.chapters.map(
            chapter =>
              chapter.id === action.activeChapterId
                ? {
                    ...chapter,
                    content: chapter.content.map(
                      item =>
                        item.type === "HTML_WITH_CSS" &&
                        item.id === action.codeId
                          ? {
                              ...item,
                              cssCodeUser: action.code
                            }
                          : item
                    )
                  }
                : chapter
          )
        }
      };

    case SET_ORIGINAL_CODE:
      return {
        ...state,
        book: {
          ...state.book,
          chapters: state.book.chapters.map(
            chapter =>
              chapter.id === action.activeChapterId
                ? {
                    ...chapter,
                    content: chapter.content.map(
                      item =>
                        item.id === action.codeId
                          ? {
                              ...item,
                              htmlCodeUser: !!item.htmlCode
                                ? item.htmlCode
                                : null,
                              cssCodeUser: !!item.cssCode ? item.cssCode : null
                            }
                          : item
                    )
                  }
                : chapter
          )
        }
      };

    case SET_ORIGINAL_REACT_CODE:
      return {
        ...state,
        book: {
          ...state.book,
          chapters: state.book.chapters.map(
            chapter =>
              chapter.id === action.activeChapterId
                ? {
                    ...chapter,
                    content: chapter.content.map(
                      item =>
                        item.id === action.codeId
                          ? {
                              ...item,
                              reactCodeUser: item.reactCode
                            }
                          : item
                    )
                  }
                : chapter
          )
        }
      };
    case SET_USER_TOKEN:
      return {
        ...state,
        user: {
          ...state.user,
          token: action.token
        }
      };
    case SET_USER_ID:
      return {
        ...state,
        user: {
          ...state.user,
          id: action.id
        }
      };
    default:
      return state;
  }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers.js